/* eslint-disable no-undef */
import { message, notification } from 'antd'
import { all, call, put, takeEvery } from 'redux-saga/effects'

import { actions } from 'src/redux/google-tag-manager/actions'
import { serviceGTM } from 'src/services/api/gtManager'

function load (payload) {
  return setState({ loading: payload })
}

function setState (payload) {
  return put({
    type: 'google_tag_manager/set_state',
    payload
  })
}

export function * getGoogleTagManager ({ payload }) {
  yield load(true)
  const { token } = payload

  const response = yield call(serviceGTM.get, token)
  if (response.status === 200) {
    yield setState({
      dataTagManager: response.data.data,
      meta: response.data.data.meta,
      loading: false
    })
  } yield load(false)
}

export function * getWithQR ({ payload }) {
  yield load(true)
  const { qrcodeId } = payload

  const response = yield call(serviceGTM.getQR, qrcodeId)
  if (response.status === 200) {
    yield setState({
      dataTagManager: response.data.data,
      meta: response.data.data.meta,
      loading: false
    })
  } yield load(false)
}

export function * createGoogleTagManager ({ payload }) {
  yield load(true)
  const { token, data } = payload

  const response = yield call(serviceGTM.create, token, data)
  if (response.status === 202) {
    yield setState({
      loading: false,
      dataTagManager: response.data.data,
      popupSuccess: true
    })
    message.success('Created success')
  } else {
    yield load(false)
    message.error('created failed! check your field')
  }
}

export function * deleteGoogleTagManager ({ payload }) {
  yield load(true)
  const { token } = payload

  const response = yield call(serviceGTM.delete, token)
  if (response.status === 202) {
    yield put({
      type: 'google_tag_manager/get',
      payload: { token }
    })
    notification.warning({
      message: 'Delete Success!',
      description: 'Data delete for permanent '
    })
  } yield load(false)
}

export default function * rootSaga () {
  yield all([
    takeEvery(actions.get_google_tag_manager, getGoogleTagManager),
    takeEvery(actions.get_with_qr, getWithQR),
    takeEvery(actions.delete_google_tag_manager, deleteGoogleTagManager),
    takeEvery(actions.create_google_tag_manager, createGoogleTagManager)
  ])
}
